import { useState, useEffect } from "react";
import Store from "../store/Store";
import {useSelector} from "react-redux";

const useTables = () => {
  //const { tables } = Store.getState();
  const tables = useSelector(state => state.tables)
  
  const [keyword, setKeyword] = useState('');
  const [tableStates, setTableStates] = useState({});
  const [allOpen, setAllOpen] = useState(false);

    useEffect(() => {
        const savedTableStates = localStorage.getItem('tableStates');
        if (!savedTableStates && tables.length > 0) {
            const initialStates = tables.reduce((acc, table) => {
                acc[table.table_id] = false; // Minden tábla bezárt
                return acc;
            }, {});
            localStorage.setItem('tableStates', JSON.stringify(initialStates));
            setTableStates(initialStates);
        }
    }, [tables]);
  
    // useEffect, hogy betöltsük a tárolt állapotokat a localStorage-ból
    useEffect(() => {
        const savedTableStates = localStorage.getItem('tableStates');
        const savedAllOpen = localStorage.getItem('allOpen');
        if (savedTableStates) {
            setTableStates(JSON.parse(savedTableStates)); // Beállítjuk a táblák állapotát
        }
        if (savedAllOpen !== null) {
            setAllOpen(JSON.parse(savedAllOpen)); // Beállítjuk az összes gomb állapotát
        }
    }, []);

    // useEffect, hogy minden állapotváltozás után elmentsük a localStorage-ba
    useEffect(() => {
        if (Object.keys(tableStates).length > 0) {
            localStorage.setItem('tableStates', JSON.stringify(tableStates)); // Az összes táblához tartozó állapotot elmentjük
        }
        localStorage.setItem('allOpen', JSON.stringify(allOpen)); // Az összes kinyitása/gomb állapotát is elmentjük
    }, [tableStates, allOpen]); // Az állapot változása esetén tároljuk a localStorage-ba

    // A tábla kinyitásának vagy bezárásának kezelése
    const toggleTableState = (tableId) => {
        setTableStates((prevState) => {
            const newState = { ...prevState };
            newState[tableId] = !newState[tableId]; // Kinyitjuk vagy bezárjuk a táblát
            return newState;
        });
    };

    // Az összes tábla kinyitása vagy becsukása
    const toggleAllTablesState = () => {
        setAllOpen((prev) => {
            const newState = !prev; // Fordítjuk az állapotot
            setTableStates(tables.reduce((acc, table) => {
                acc[table.table_id] = newState; // Minden tábla állapotát beállítjuk az új állapotra
                return acc;
            }, {}));
            return newState;
        });
    };


  const filteredTables = tables.filter(table => table.name.toLowerCase().includes(keyword.toLowerCase()));

  return {
    keyword,
    setKeyword,
    tableStates,
    allOpen,
    setAllOpen,
    toggleTableState,
    toggleAllTablesState,
    filteredTables,
  };
};

export default useTables;
